import Header from "components/dashHeader";
import PickCountryNumber from "components/pickCountryNumberAirtime";
//import { Link } from "react-router-dom";
import Sidemenu from "components/sidemenu";
import { debounce } from "lodash";
import React, { Component } from "react";
import Check2 from "../../../assets/icons/pop-check.svg";
//import NumberFormat from 'react-number-format';
import Cancel from "../../../assets/icons/sm-x.svg";
import Load from "../../../assets/svg/other/loading2.svg";
//
import { get, post } from "../../../util/axiosLib";
import { logger } from "../../../util/logger";
import { getExchangeRate, isNumeric } from "../../../util/utils";

export default class BuyAirtime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      walletBalance: 0,
      selectedCurrency: "ngn",
      selectedWallet: "btc",
      fiatAmount: 0,
      airtimeAmount: 0,
      dataPrice: 0,
      dataPlans: [],
      summaryClicked: false,
      summaryClicked2: false,
      enterPin: false,
      enterPin2: false,
      bill: "airtime",
    };

    this.token = localStorage.getItem("tokenset");
    this.userData = JSON.parse(localStorage.getItem("btm_user"));
    this.headers = {
      authorization: `${this.token}`,
      "Content-Type": "application/json",
    };

    this.calculateValue = debounce(this.calculateValue, 1000);
    this.calculateValueFiat = debounce(this.calculateValueFiat, 1000);
  }

  calculateValue = async (value) => {
    // This function is debounced
    if (isNumeric(value)) {
      const usCoins = ["usdt", "cusd", "usdc", "usdt-tron"];
      let coin;
      coin = usCoins.includes(this.state.selectedWallet)
        ? "usd"
        : this.state.selectedWallet;

      if (this.state.selectedWallet === "tbtc") {
        coin = "btc";
      }
      if (this.state.selectedWallet === "teth") {
        coin = "eth";
      }
      if (this.state.selectedWallet === "ceur") {
        coin = "eur";
      }
      //logger("coin gotten",coin)
      const ticker = `${coin}${this.state.selectedCurrency}`;
      const exchangeRate = await getExchangeRate(ticker, "sell");
      const fiatAmount = Number((exchangeRate * value).toFixed(2));
      this.setState({
        sellPrice: exchangeRate,
        fiatAmount,
        ticker,
        canSell: true,
      });
    } else {
      this.setState({ fiatAmount: 0, canSell: false });
    }
  };
  calculateValueFiat = async (value) => {
    // This function is debounced
    if (isNumeric(value)) {
      const usCoins = ["usdt", "cusd", "usdc", "usdt-tron"];
      let coin;
      coin = usCoins.includes(this.state.selectedWallet)
        ? "usd"
        : this.state.selectedWallet;

      if (this.state.selectedWallet === "tbtc") {
        coin = "btc";
      }
      if (this.state.selectedWallet === "teth") {
        coin = "eth";
      }
      if (this.state.selectedWallet === "ceur") {
        coin = "eur";
      }
      //logger("coin gotten",coin)
      const ticker = `${coin}${this.state.selectedCurrency}`;
      const exchangeRate = await getExchangeRate(ticker, "sell");
      const airtimeAmount = Number((value / exchangeRate).toFixed(2));
      console.log("rate", exchangeRate, "value", value);
      console.log(airtimeAmount);
      this.setState({
        //sellPrice: exchangeRate,
        airtimeAmount,
        //ticker,
        canSell: true,
      });
    } else {
      this.setState({ fiatAmount: 0, canSell: false });
    }
  };

  loadWallets = async () => {
    try {
      const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/wallets`;
      const getWalletReq = await get(endpoint, this.headers);

      this.setState({
        userWallets: getWalletReq.data?.data?.addresses?.data?.addresses,
        walletBalance:
          getWalletReq.data?.data?.addresses?.data?.addresses[10]?.balance
            .$numberDecimal,
      });
      //ogger("wallets>>",this.state.userWallets)
    } catch (err) {
      const errData = err.response;
      logger(errData);
      if (errData?.status === 403 || errData?.status === 401) {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({ incorrectError: "Token expired, please login again." });

        setTimeout(() => {
          window.location = "/";
        }, 2000);
      }
    }
  };

  // Handles change in coin selection dropdown
  handleCoinChange = async (event) => {
    await this.setState({ selectedWallet: event.target.value });
    //logger(this.state.selectedWallet)
    //this.setState({ selectedCoin: event.target.value });
    if (this.state.airtimeAmount !== 0) {
      await this.calculateValue(this.state.airtimeAmount);
    }
    if (this.state.fiatAmount !== 0) {
      await this.calculateValueFiat(this.state.fiatAmount);
    }

    const coinWallet = await this.state.userWallets.find(function (wallet) {
      return event.target.value === wallet.coin;
    });
    const walletBalance = coinWallet.balance.$numberDecimal;

    this.setState({ walletBalance });
  };

  // Handle all input changes
  handleInputChange = async (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    await this.setState({
      [name]: value,
    });

    const ebtn = document.getElementById("actionBtn");
    await ebtn.classList.add("e-disable");

    const errmsg = document.getElementById("error-info2");
    errmsg.classList.remove("err-auth-on");
    await this.setState({ incorrectError: " " });

    if (name === "airtimeAmount") {
      await this.calculateValue(value);

      const numberRegex = /(?=[a-zA-Z])/;
      if (numberRegex.test(event.target.value) || event.target.value < 0) {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({ incorrectError: "Please enter only valid numbers" });
      }
    }
    if (name === "selectedCurrency") {
      if (this.state.airtimeAmount !== 0) {
        await this.calculateValue(this.state.airtimeAmount);
      }
      this.setState({ dataPrice: 0 });
    }
    if (name === "phoneNo") {
      if (this.state.phoneNo[0] === "0") {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({ incorrectError: "No leading Zero (0)" });
      }
    }

    if (name === "fiatAmount") {
      await this.calculateValueFiat(value);

      const numberRegex2 = /(?=[a-zA-Z])/;
      if (numberRegex2.test(event.target.value) || event.target.value < 0) {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({ incorrectError: "Please enter only valid numbers" });
      }
    }

    //logger(this.state.phoneNo)

    if (
      (this.state.airtimeAmount || this.state.dataPrice) &&
      this.state.phoneNo
    ) {
      const ebtn = document.getElementById("actionBtn");
      await ebtn.classList.remove("e-disable");
    } else {
      const ebtn = document.getElementById("actionBtn");
      await ebtn.classList.add("e-disable");
    }

    if (this.state.selectedCurrency && this.state.selectedNetwork) {
      const countryCode = this.state.selectedCurrency;
      const network = this.state.selectedNetwork;
      const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/wallet/bills/internetPlans?countryCode=${countryCode}&network=${network}`;
      const dataPlansReq = await get(endpoint, this.headers);
      logger(dataPlansReq.data.data.plans);
      //console.log(dataPlansReq.data.data.plans[0].service )
      this.setState({
        dataPlans: dataPlansReq.data.data.plans,
      });
    }
    if (this.state.selectedDataPlan) {
      //logger(this.state.selectedDataPlan)
      const dataPrice = this.state.selectedDataPlan.substr(5);
      const planId = this.state.selectedDataPlan.substr(0, 4);
      this.setState({
        dataPrice,
        planId,
      });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.userData.twoFactor === false) {
      const errmsg = document.getElementById("error-info2");
      errmsg.classList.add("err-auth-on");
      this.setState({ incorrectError: "Please enable 2fa" });
      setTimeout(() => {
        window.location = "/2fagenerate";
      }, 2100);
    } else {
      if (this.state.fiatAmount < 1000 || this.state.fiatAmount > 50000) {
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.add("err-auth-on");
        this.setState({
          incorrectError: "Fiat amount should be between 500 - 50,000",
        });
      } else {
        this.setState({
          summaryClicked: true,
        });
      }
    }
  };
  // For Data
  handleSubmit2 = (event) => {
    event.preventDefault();
    if (this.userData.twoFactor === false) {
      const errmsg = document.getElementById("error-info2");
      errmsg.classList.add("err-auth-on");
      this.setState({ incorrectError: "Please enable 2fa" });
      setTimeout(() => {
        window.location = "/2fagenerate";
      }, 2100);
    } else {
      this.setState({
        summaryClicked2: true,
      });
    }
  };

  createPin = async () => {
    localStorage.setItem("changePinStatus", true);

    setTimeout(() => {
      window.location = "/dashboard/accountedit";
    }, 1000);
  };

  handlePinSubmit = async (event) => {
    event.preventDefault();

    const ebtn = document.getElementById("summaryBtn2");
    await ebtn.classList.add("e-disable");

    //loading..
    const loaded2 = document.getElementById("loadla2");
    loaded2.classList.add("load-aa-on");

    const countryCode = localStorage.getItem("countryCodeA");

    try {
      const reqBody = {
        pin: this.state.pin,
        country: this.state.selectedCurrency,
        coin: this.state.selectedWallet,
        amount: this.state.airtimeAmount,
        phone: countryCode + this.state.phoneNo,
      };

      const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/wallet/bills/airtime`;
      const airtimeReq = await post(endpoint, reqBody, this.headers);

      logger("Airtime REQ RESPONSE::: ", airtimeReq);

      if (airtimeReq.data.status === "success") {
        this.setState({
          summaryClicked: false,
          enterPin: false,
          popUpClicked: true,
        });
      }
    } catch (err) {
      logger("Airtime ERROR::: ", err.response);
      //   this.setState({
      //     errorMessage: err.response.data.error,
      //   });
      //   const errmsg = document.getElementById("error-info");
      //   errmsg.classList.add("error-info-on");
      //   loaded2.classList.remove("load-aa-on");
      if (err.isAxiosError) {
        const errData = err.response;
        this.setState({
          errorMessage: errData.data.error,
        });
        const errmsg = document.getElementById("error-info");
        errmsg.classList.add("error-info-on");

        loaded2.classList.remove("load-aa-on");
        ebtn.classList.remove("e-disable");
      }
    }
  };

  // For Data
  handlePinSubmit2 = async (event) => {
    event.preventDefault();

    const ebtn = document.getElementById("summaryBtn2");
    await ebtn.classList.add("e-disable");

    //loading..
    const loaded2 = document.getElementById("loadla2");
    loaded2.classList.add("load-aa-on");

    const countryCode = localStorage.getItem("countryCodeA");

    try {
      const reqBody = {
        countryCode: this.state.selectedCurrency,
        product_id: this.state.planId,
        amount: this.state.dataPrice,
        phone: countryCode + this.state.phoneNo,
        coin: this.state.selectedWallet,
        pin: this.state.pin,
      };

      const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/wallet/bills/internet`;
      const dataReq = await post(endpoint, reqBody, this.headers);

      logger("Data REQ RESPONSE::: ", dataReq);

      if (dataReq.data.status === "success") {
        this.setState({
          summaryClicked2: false,
          enterPin2: false,
          popUpClicked2: true,
        });
      }
    } catch (err) {
      logger("data ERROR::: ", err.response);
      if (err.isAxiosError) {
        logger(err);
        // const errData = err.response;
        this.setState({
          errorMessage: "Something went wrong, contact admin.",
          //errorMessage: err[1].data.error.message,
        });
        const errmsg = document.getElementById("error-info");
        errmsg.classList.add("error-info-on");

        loaded2.classList.remove("load-aa-on");
        ebtn.classList.remove("e-disable");
      }
    }
  };

  handleSummary = async (event) => {
    event.preventDefault();

    await this.setState({
      enterPin: true,
    });
  };
  handleSummary2 = async (event) => {
    event.preventDefault();

    await this.setState({
      enterPin2: true,
    });
  };

  handleClose = async () => {
    this.setState({
      popUpClicked: false,
      popUpClicked2: false,
    });
    window.location.reload();
  };

  componentDidMount() {
    this.loadWallets();
  }

  render() {
    const currentPage = "Voucher";

    return (
      <div>
        <Sidemenu currentPage={currentPage} />
        <Header />

        {this.state.popUpClicked ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__slideInDown">
                <div className="popup-img">
                  <img
                    className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Check2}
                    alt=""
                  />
                </div>
                <h2>
                  {this.state.selectedCurrency === "ngn" && (
                    <p>
                      ₦{this.state.fiatAmount}
                      <br />
                      <span className="sm-popup-txt">
                        Airtime purchased
                      </span>{" "}
                    </p>
                  )}
                  {this.state.selectedCurrency === "ghs" && (
                    <p>
                      GH₵{this.state.fiatAmount}
                      <br />{" "}
                      <span className="sm-popup-txt">Airtime purchased</span>
                    </p>
                  )}
                </h2>
                {/* <p className="popup-success">Airtime purchase Successfull</p> */}
                <button onClick={this.handleClose} className="popup-close-btn">
                  Close
                </button>
              </div>
            </section>
          </div>
        ) : null}

        {this.state.popUpClicked2 ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="popup">
              <div className="popup-box animate__animated animate__slideInDown">
                <div className="popup-img">
                  <img
                    className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                    src={Check2}
                    alt=""
                  />
                </div>
                <h2>
                  {this.state.selectedCurrency === "ngn" && (
                    <p>
                      ₦{this.state.dataPrice}
                      <br />
                      <span className="sm-popup-txt">Data purchased</span>{" "}
                    </p>
                  )}
                  {this.state.selectedCurrency === "ghs" && (
                    <p>
                      GH₵{this.state.dataPrice}
                      <br /> <span className="sm-popup-txt">Datapurchased</span>
                    </p>
                  )}
                </h2>
                {/* <p className="popup-success">Airtime purchase Successfull</p> */}
                <button onClick={this.handleClose} className="popup-close-btn">
                  Close
                </button>
              </div>
            </section>
          </div>
        ) : null}

        {this.state.summaryClicked ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="summaryclicked">
              <div className="summaryclicked-box animate__animated animate__slideInUp">
                <div className="sc-top">
                  <h2 className=""> Summary</h2>
                  <img
                    onClick={() => this.setState({ summaryClicked: false })}
                    src={Cancel}
                    alt="close"
                  />
                </div>
                <div className="sc-items">
                  <p className="sc-item-title">Buying Airtime From</p>
                  <p>{this.state.selectedWallet.toUpperCase()} Wallet</p>
                </div>

                <div className="sc-items-last">
                  <p className="sc-item-title">
                    Amount in {this.state.selectedWallet.toUpperCase()}
                  </p>
                  <p>
                    <span>
                      {Number(this.state.airtimeAmount).toLocaleString()}{" "}
                    </span>{" "}
                    {/* {this.state.selectedFiatWallet.toUpperCase()}{" "} */}
                  </p>
                </div>

                <div className="sc-items-last">
                  <p className="sc-item-title">
                    {" "}
                    Amount in {this.state.selectedCurrency.toUpperCase()}
                  </p>
                  <p>
                    <span>
                      {Number(this.state.fiatAmount).toLocaleString()}{" "}
                    </span>{" "}
                    {/* {this.state.selectedFiatWallet.toUpperCase()}{" "} */}
                  </p>
                </div>

                <div className="sc-items-last">
                  <p className="sc-item-title"> Phone Number</p>
                  <p>
                    <span>
                      {localStorage.getItem("countryCodeA") +
                        this.state.phoneNo}{" "}
                    </span>{" "}
                    {/* {this.state.selectedFiatWallet.toUpperCase()}{" "} */}
                  </p>
                </div>
                <button
                  id="summaryBtn"
                  onClick={this.handleSummary}
                  className="summaryclicked-btn"
                >
                  Submit
                </button>
                <div id="loadla" className="load-aa">
                  <img src={Load} alt="loading" />
                </div>
              </div>
            </section>
          </div>
        ) : null}

        {this.state.summaryClicked2 ? (
          <div>
            <div className="overlay animate__animated animate__fadeIn "></div>
            <section className="summaryclicked">
              <div className="summaryclicked-box animate__animated animate__slideInUp">
                <div className="sc-top">
                  <h2 className=""> Summary</h2>
                  <img
                    onClick={() => this.setState({ summaryClicked2: false })}
                    src={Cancel}
                    alt="close"
                  />
                </div>
                <div className="sc-items">
                  <p className="sc-item-title">Buying Data From</p>
                  <p>{this.state.selectedWallet.toUpperCase()} Wallet</p>
                </div>

                <div className="sc-items-last">
                  <p className="sc-item-title"> Mobile Network</p>
                  <p>
                    <span>
                      {this.state.selectedNetwork.toLocaleUpperCase()}
                    </span>{" "}
                    {/* {this.state.selectedFiatWallet.toUpperCase()}{" "} */}
                  </p>
                </div>
                {/* <div className="sc-items-last">
                                <p className="sc-item-title"> Data Plan</p>
                                <p>
                                    <span>
                                    {this.state.selectedNetwork.toLocaleUpperCase()}
                                    </span>{" "}
                                   
                                </p>
                            </div> */}
                {/* <div className="sc-items-last">
                                <p className="sc-item-title"> Amount in {this.state.selectedCurrency.toUpperCase()}</p>
                                <p>
                                    <span>
                                    {Number(this.state.fiatAmount).toLocaleString()}{" "}
                                    </span>{" "}
                                </p>
                            </div> */}
                <div className="sc-items-last">
                  <p className="sc-item-title">
                    {" "}
                    Amount in {this.state.selectedCurrency.toUpperCase()}
                  </p>
                  <p>
                    <span>
                      {Number(this.state.dataPrice).toLocaleString()}{" "}
                    </span>{" "}
                    {/* {this.state.selectedFiatWallet.toUpperCase()}{" "} */}
                  </p>
                </div>

                <div className="sc-items-last">
                  <p className="sc-item-title"> Phone Number</p>
                  <p>
                    <span>
                      {localStorage.getItem("countryCodeA") +
                        this.state.phoneNo}{" "}
                    </span>{" "}
                    {/* {this.state.selectedFiatWallet.toUpperCase()}{" "} */}
                  </p>
                </div>
                <button
                  id="summaryBtn"
                  onClick={this.handleSummary2}
                  className="summaryclicked-btn"
                >
                  Submit
                </button>
                <div id="loadla" className="load-aa">
                  <img src={Load} alt="loading" />
                </div>
              </div>
            </section>
          </div>
        ) : null}

        {this.state.enterPin ? (
          <div>
            <div className="overlay3 animate__animated animate__fadeIn "></div>
            <section className="summaryclicked">
              <div className="summaryclicked-box2 animate__animated animate__slideInDown">
                <div className="sc-top">
                  <h2 className="">Enter Pin</h2>
                  <img
                    onClick={() => this.setState({ enterPin: false })}
                    src={Cancel}
                    alt="close"
                  />
                </div>
                <form
                  className="wallet-withdraw-form"
                  onSubmit={this.handlePinSubmit}
                >
                  <div className="ww-inputs">
                    <p>Please enter your pin for withdrawal</p>
                    <input
                      type="password"
                      placeholder="Enter your pin"
                      id="pin"
                      name="pin"
                      defaultValue={this.state.pin}
                      onChange={this.handleInputChange}
                      maxLength="6"
                      required
                    />
                  </div>
                  <p className="tiny-txt3 left-m1">
                    (Don't have a pin?{" "}
                    <span className="pointer green" onClick={this.createPin}>
                      Create one
                    </span>
                    )
                  </p>

                  <button
                    //onClick={this.handlePinSubmit}
                    className="summaryclicked-btn"
                    id="summaryBtn2"
                  >
                    Submit
                  </button>
                  <div id="loadla2" className="load-aa">
                    <img src={Load} alt="loading" />
                  </div>
                </form>
                <div
                  id="error-info"
                  className="error-info animate__animated animate__fadeIn "
                >
                  <p>{this.state.errorMessage}</p>
                </div>
              </div>
            </section>
          </div>
        ) : null}

        {this.state.enterPin2 ? (
          <div>
            <div className="overlay3 animate__animated animate__fadeIn "></div>
            <section className="summaryclicked">
              <div className="summaryclicked-box2 animate__animated animate__slideInDown">
                <div className="sc-top">
                  <h2 className="">Enter Pin</h2>
                  <img
                    onClick={() => this.setState({ enterPin2: false })}
                    src={Cancel}
                    alt="close"
                  />
                </div>
                <form
                  className="wallet-withdraw-form"
                  onSubmit={this.handlePinSubmit2}
                >
                  <div className="ww-inputs">
                    <p>Please enter your pin for withdrawal</p>
                    <input
                      type="password"
                      placeholder="Enter your pin"
                      id="pin"
                      name="pin"
                      defaultValue={this.state.pin}
                      onChange={this.handleInputChange}
                      maxLength="6"
                      required
                    />
                  </div>
                  <p className="tiny-txt3 left-m1">
                    (Don't have a pin?{" "}
                    <span className="pointer green" onClick={this.createPin}>
                      Create one
                    </span>
                    )
                  </p>

                  <button
                    //onClick={this.handlePinSubmit}
                    className="summaryclicked-btn"
                    id="summaryBtn2"
                  >
                    Submit
                  </button>
                  <div id="loadla2" className="load-aa">
                    <img src={Load} alt="loading" />
                  </div>
                </form>
                <div
                  id="error-info"
                  className="error-info animate__animated animate__fadeIn "
                >
                  <p>{this.state.errorMessage}</p>
                </div>
              </div>
            </section>
          </div>
        ) : null}

        <section className="home">
          <div className="home-container">
            <div className="home-buy-content">
              <h1> Bill Payment </h1>
            </div>
            <div
              id="error-info2"
              className="err-auth zindex animate__animated animate__slideInDown"
            >
              <p>
                <strong>{this.state.incorrectError}</strong>
              </p>
            </div>
            <div className="hw-box">
              {/* <p className="hw-p-sp0">Kindly fill in details for airtime recharge.</p> */}
              <div className="hw-inputs">
                <p className="hw-p-sp2"> Select Bill </p>
                <select
                  className="hw-drop"
                  name="selectedCurrency"
                  onChange={(e) => this.setState({ bill: e.target.value })}
                  //defaultValue={this.state.fiatCurrency}
                >
                  <option value="airtime">Airtime Recharge</option>
                  <option value="data">Data Subscription</option>
                </select>
              </div>
              {this.state.bill === "airtime" && (
                <form onSubmit={this.handleSubmit} className="hw-form">
                  <div className="hw-inputs">
                    <p className="hw-p-sp1">Select Wallet</p>
                    <select
                      className="hw-drop"
                      name="selectedWallet"
                      onChange={this.handleCoinChange}
                      //defaultValue={this.state.fiatCurrency}
                    >
                      <option value={process.env.REACT_APP_COIN_A}>
                        {" "}
                        {process.env.REACT_APP_COIN_A.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_B}>
                        {" "}
                        {process.env.REACT_APP_COIN_B.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_C}>
                        {" "}
                        {process.env.REACT_APP_COIN_C.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_D}>
                        {" "}
                        {process.env.REACT_APP_COIN_D.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_E}>
                        {" "}
                        cUSD
                      </option>
                      <option value={process.env.REACT_APP_COIN_F}>
                        {" "}
                        {process.env.REACT_APP_COIN_F.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_G}>
                        {" "}
                        {process.env.REACT_APP_COIN_G.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_H}>
                        {process.env.REACT_APP_COIN_H.toUpperCase()}
                      </option>
                      <option value={process.env.REACT_APP_COIN_I}>
                        {process.env.REACT_APP_COIN_I.toUpperCase()}
                      </option>
                      <option value={process.env.REACT_APP_COIN_L}>cEUR</option>
                    </select>
                  </div>
                  <p className="coin-bal2 ">
                    {/* <span className="right-m0"> Coin balance:  </span> */}{" "}
                    {Number(this.state.walletBalance).toFixed(8)}{" "}
                  </p>
                  <div className="hw-inputs">
                    <p className="hw-p-sp2"> Select Currency </p>
                    <select
                      className="hw-drop"
                      name="selectedCurrency"
                      onChange={this.handleInputChange}
                      //defaultValue={this.state.fiatCurrency}
                    >
                      <option value="ngn">Nigerian Naira (NGN)</option>
                      <option value="ghs">Ghana Cedi (GHS)</option>
                    </select>
                  </div>
                  <div className="hw-inputs2">
                    <p className="hw-p-sp1"> Phone Number</p>
                    <PickCountryNumber />
                    <input
                      type="text"
                      name="phoneNo"
                      placeholder="Phone number without the first zero"
                      maxLength="10"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="hw-inputs">
                    <p className="hw-p-sp1">
                      Amount in {this.state.selectedWallet.toLocaleUpperCase()}
                    </p>
                    <input
                      type="text"
                      name="airtimeAmount"
                      placeholder="Amount"
                      //defaultValue={this.state.airtimeAmount}
                      value={this.state.airtimeAmount}
                      //value={<NumberFormat value={this.state.airtimeAmount}
                      //displayType={'text'}
                      //thousandSeparator={true}  /> }
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="hw-inputs">
                    <p className="hw-p-sp1">
                      Amount in{" "}
                      {this.state.selectedCurrency.toLocaleUpperCase()}
                    </p>
                    <input
                      type="text"
                      name="fiatAmount"
                      placeholder="Amount"
                      //disabled
                      //defaultValue={this.state.fiatAmount}
                      value={this.state.fiatAmount}
                      onChange={this.handleInputChange}
                    />
                  </div>

                  {/* <button id="createBtn" className="hw-inputs p2p-submit e-disable" type="submit">
                                    Buy
                                </button> */}
                  <button
                    id="actionBtn"
                    className="hw-btn-a e-disable"
                    type="submit"
                  >
                    Buy Airtime
                  </button>
                  {/* <button id="wi-btn" type="submit" className="hr-btn-s w-disable">
                                    {" "}
                                    Send
                                </button> */}
                </form>
              )}

              {this.state.bill === "data" && (
                <form onSubmit={this.handleSubmit2} className="hw-form">
                  <div className="hw-inputs">
                    <p className="hw-p-sp1">Select Wallet</p>
                    <select
                      className="hw-drop"
                      name="selectedWallet"
                      onChange={this.handleCoinChange}
                      //defaultValue={this.state.fiatCurrency}
                    >
                      <option value={process.env.REACT_APP_COIN_A}>
                        {" "}
                        {process.env.REACT_APP_COIN_A.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_B}>
                        {" "}
                        {process.env.REACT_APP_COIN_B.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_C}>
                        {" "}
                        {process.env.REACT_APP_COIN_C.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_D}>
                        {" "}
                        {process.env.REACT_APP_COIN_D.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_E}>
                        {" "}
                        cUSD
                      </option>
                      <option value={process.env.REACT_APP_COIN_F}>
                        {" "}
                        {process.env.REACT_APP_COIN_F.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_G}>
                        {" "}
                        {process.env.REACT_APP_COIN_G.toUpperCase()}{" "}
                      </option>
                      <option value={process.env.REACT_APP_COIN_H}>
                        {process.env.REACT_APP_COIN_H.toUpperCase()}
                      </option>
                      <option value={process.env.REACT_APP_COIN_I}>
                        {process.env.REACT_APP_COIN_I.toUpperCase()}
                      </option>
                      <option value={process.env.REACT_APP_COIN_L}>cEUR</option>
                    </select>
                  </div>
                  <p className="coin-bal2 ">
                    {/* <span className="right-m0"> Coin balance:  </span> */}{" "}
                    {Number(this.state.walletBalance).toFixed(8)}{" "}
                  </p>
                  <div className="hw-inputs">
                    <p className="hw-p-sp2"> Select Currency </p>
                    <select
                      className="hw-drop"
                      name="selectedCurrency"
                      onChange={this.handleInputChange}
                      //defaultValue={this.state.fiatCurrency}
                    >
                      <option value="ngn">Nigerian Naira (NGN)</option>
                      <option value="ghs">Ghana Cedi (GHS)</option>
                    </select>
                  </div>
                  <div className="hw-inputs">
                    <p className="hw-p-sp1"> Select Network </p>
                    <select
                      className="hw-drop"
                      name="selectedNetwork"
                      onChange={this.handleInputChange}
                      //defaultValue={this.state.fiatCurrency}
                    >
                      <option value=" ">Select Network</option>
                      <option value="mtn">Mtn</option>
                      <option value="airtel">Airtel</option>
                    </select>
                  </div>
                  <div className="hw-inputs">
                    <p className="hw-p-sp1"> Choose Data Plan </p>
                    <select
                      className="hw-drop"
                      name="selectedDataPlan"
                      onChange={this.handleInputChange}
                      //defaultValue={this.state.fiatCurrency}
                    >
                      <option value="">
                        Pls enter currency and network to see plans.
                      </option>
                      {this.state.dataPlans.length >= 1 &&
                        this.state.dataPlans.map((plan) => (
                          <option
                            value={plan.product_id + "/" + plan.range[0]}
                            key={plan.product_id}
                          >
                            {plan.service}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="hw-inputs">
                    <p className="hw-p-sp1">Data Price</p>
                    <input
                      type="text"
                      name="dataPrice"
                      placeholder="Amount"
                      //defaultValue={this.state.airtimeAmount}
                      value={
                        this.state.dataPrice +
                        " " +
                        this.state.selectedCurrency.toLocaleUpperCase()
                      }
                      //value={<NumberFormat value={this.state.airtimeAmount}
                      //displayType={'text'}
                      //thousandSeparator={true}  /> }
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="hw-inputs2">
                    <p className="hw-p-sp1"> Phone Number</p>
                    <PickCountryNumber />
                    <input
                      type="text"
                      name="phoneNo"
                      placeholder="Phone number without the first zero"
                      maxLength="10"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <br></br>

                  <button
                    id="actionBtn"
                    className="hw-btn-a e-disable"
                    type="submit"
                  >
                    Buy Data
                  </button>
                  {/* <button id="wi-btn" type="submit" className="hr-btn-s w-disable">
                                    {" "}
                                    Send
                                </button> */}
                </form>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
